<script>
    import TopBackground from './top-background.svelte'
    import Selector from './selector.svelte'
    import Text from './text.svelte'
    import TextLink from './text_links.svelte'
    import Icons from './icons.svelte'

    export let theme
    export let primary
    export let secondary

    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'

    $: backgroundImage = `${staticAssetPrefix}img/onboarding/${
        theme === true ? 'team-background-dark.png' : 'team-background.png'
    }`
</script>

<style>
    .fno-preview {
        width: 414px;
        height: 896px;
        position: relative;
        margin-bottom: 25px;
    }
</style>

<div class="fno-preview" style="background-image: url({backgroundImage});">
    <TopBackground fill={primary} />
    <Selector fill={secondary} />
    <Text fill={secondary} />
    <TextLink fill={theme ? '#FFF' : '#000'} />
    <Icons fill={primary} />
</div>
